import { gql } from "@apollo/client";

import { caseFragment } from "./CaseFragment";
import { scenarioExecutionResultWithCaseFragment } from "./ScenarioExecutionResultWithCaseFragment";
import { shortAlertFragment } from "./ShortAlertFragment";

export const alertFragment = gql`
  fragment AlertFragment on Alert {
    ...ShortAlertFragment
    origin
    financialLossAmount
    preventedFraudAmount
    comment
    nbrOfIdentifiedCases
    scenarioExecutionResult {
      ...ScenarioExecutionResultWithCaseFragment
    }
    fraudType {
      name
    }
    attachments {
      id
      name
      fileId
      contentType
      currentVersionId
    }
    caseVersions {
      current {
        ...CaseFragment
      }
      creation {
        ...CaseFragment
      }
      validation {
        ...CaseFragment
      }
    }
  }

  ${scenarioExecutionResultWithCaseFragment}
  ${shortAlertFragment}
  ${caseFragment}
`;
